import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import List from "./pages/list/List";
import Home from "./pages/home/Home";
import Hotel from "./pages/hotel/Hotel";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/hotels" element={<List />}></Route>
        <Route path="/hotels/:id" element={<Hotel />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
